(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('scoring', scoring);

	scoring.$inject = ['$rootScope', '$scope', '$timeout', '$location', 'assessmentService', 'leanFilterService', 'ASSESSMENTS', '$state', 'storeService'];

	function scoring($rootScope, $scope, $timeout, $location, assessmentService, leanFilterService, ASSESSMENTS, $state, storeService) {
		var vm = this;

		// Redirect to projects if not allowed to current customer
		if (ASSESSMENTS.allowedCustomers.indexOf(globalConfig.customer.id) < 0)  {
			$location.path('/lean-projects/view-projects').replace();
		}

		var unsubscribe;
		var reportSettingsName = 'assessment-scoring';
		var extraParams = [{}];
		var defaultFilters = [
			{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }
		];

		function navigateToBaseReport() {
			$state.go('.', { reportId: undefined });
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		if (reportSettingsId) {
			vm.showInfo = true;
		}
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			showExcel: false,
			hideSearch: true
		};
		vm.reportTitle = 'Assessment chart';
		vm.baseReportDisplay = vm.reportTitle;
		$scope.baseReportName = vm.baseReportDisplay;
		$scope.filterService = leanFilterService;
		
		vm.getData = getData;
		vm.getMeta = getMeta;

		function getMeta() {
			return meta;
		}

		function getData() {
			assessmentService.getRatingsBySystemNameChartData().then(function (data) {
				if (data && data.length > 0) {
					$scope.empty = false;
					$scope.rawData = data;
					$rootScope.$emit('assessmentScoringDataReady');
				} else {
					$scope.empty = true;
				}
			});
		}

		function init() {
			$scope.initialLoad = true;
			$scope.initialReadFromConfig = true;
			$scope.loading = true;
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = true;

			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;

			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {
				vm.userDescription = reportSettings.userDescription;
				vm.reportTitle = storeService.getState().reportSettings.reportName;
				
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		init();
	}
})();